// components/AssetReportFilterBar.tsx
import React, { useCallback, useState } from 'react';
import {useLocation } from 'react-router-dom';
import { FilterDropdown } from './FilterDropdown';
import { DateRangeFilter } from './DateRangeFilter';
import {  AssetReportFilters } from './types';
import { DEFAULT_FILTERS } from './constants';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import configs from '../../../configs/config';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { addDays, subMonths } from 'date-fns';

interface AssetReportFilterBarProps {
  onFilterChange: (filters: AssetReportFilters) => void;
  saveReport: () => void;
  initialValues?: {
    filters: AssetReportFilters;
  };
}
const getDefaultValue = (isDateString?: boolean) =>{
  const temp:any = DEFAULT_FILTERS;
  temp.startDate = subMonths(new Date(), 1);
  temp.endDate = addDays(new Date(), 0);
  if(isDateString){
    temp.startDate = temp.startDate //toISOString().split('T')[0];
    temp.endDate = temp.endDate //toISOString().split('T')[0];
  }
  return temp;
}
export const AssetReportFilterBar: React.FC<AssetReportFilterBarProps> = ({ onFilterChange, saveReport, initialValues }) => {
  const navigate = useNavigate();
  const pageUrl = useLocation();
  const subRoute = pageUrl.pathname.split("/")[1]
  const temp = getDefaultValue();
  const [statusIds, setStatusIds] = useState<number[]>(initialValues?.filters?.statusIds || []);
  const [assetTypeIds, setAssetTypeIds] = useState<number[]>(initialValues?.filters?.assetTypeIds || []);
  const [dateRange, setDateRange] = useState<any>({
    startDate:  initialValues?.filters?.startDate ? new Date(initialValues?.filters?.startDate) : temp.startDate,
    endDate: initialValues?.filters?.endDate ? new Date(initialValues?.filters?.endDate) : temp.endDate,
    dateFilterType: initialValues?.filters?.dateFilterType || temp.dateFilterType,
  });

  const handleStatusChange = useCallback((ids: number[]) => {
    setStatusIds(ids);
    onFilterChange({
      statusIds: ids,
      assetTypeIds,
      dateFilterType: dateRange?.dateFilterType,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
    });
  }, [assetTypeIds, dateRange, onFilterChange]);

  const handleAssetTypeChange = useCallback((ids: number[]) => {
    setAssetTypeIds(ids);
    onFilterChange({
      statusIds,
      assetTypeIds: ids,
      dateFilterType: dateRange?.dateFilterType,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
    });
  }, [statusIds, dateRange, onFilterChange]);

  const handleDateRangeChange = useCallback((range: { startDate: Date; endDate: Date; dateFilterType: string }) => {
    const newDateRange = {
      startDate: range.startDate,//.toISOString().split('T')[0],
      endDate: range.endDate,//.toISOString().split('T')[0],
      dateFilterType: range.dateFilterType,
    };
    setDateRange(newDateRange);
    onFilterChange({
      statusIds,
      assetTypeIds,
      dateFilterType: range.dateFilterType,
      startDate: range.startDate, //toISOString().split('T')[0],
      endDate: range.endDate //toISOString().split('T')[0],
    });
  }, [statusIds, assetTypeIds, onFilterChange]);

  
  const resetHandler = () =>{
    const temp = getDefaultValue();
    const {dateFilterType, startDate, endDate} = temp;
    setStatusIds(temp.statusIds);
    setAssetTypeIds(temp.assetTypeIds);
    setDateRange({dateFilterType, startDate, endDate});
    onFilterChange(temp);
  }
  const count = statusIds.length + assetTypeIds.length;
  return (
    <div className='row m-0 justify-content-between align-items-center asset-filter'>
      <div>
        <div className="asset-filter-bar row m-0" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
          <Box>
             <div className="filter-dropdown">
                  <Typography className="filter-dropdown-title cursor-pointer" variant="subtitle2" gutterBottom><FilterAltOutlinedIcon /> Filter {count > 0 ? `(${count})` : ""} <ArrowDropDownIcon /></Typography>
                  <Box className="filter-dropdown-options">
                    <Box className="filter-dropdown-options-row">
                      <Box className="col-6">
                        <FilterDropdown
                          url={`${configs?.BASE_URL}/AssetStatus`}
                          title="Asset Status"
                          selectedIds={statusIds}
                          onChange={handleStatusChange}
                        />
                      </Box>
                      <Box className="col-6">
                        <FilterDropdown
                          url={`${configs?.BASE_URL}/AssetType`}
                          title="Asset Type"
                          selectedIds={assetTypeIds}
                          onChange={handleAssetTypeChange}
                        />
                      </Box>
                      </Box>
                  </Box>
                  
              </div>
          </Box>
          
          
          <DateRangeFilter defaultVal={dateRange} onChange={handleDateRangeChange} />

          <Box>
            <Button className="reset-btn" onClick={resetHandler} variant="text"  sx={{ color:"unset" }}>
              Reset Filters
            </Button>
          </Box>
        </div>
      </div>
      {subRoute == "ViewAssetsCSVReport" ? "" : <div>
        <Button onClick={()=>navigate('/AssetsReportList')} variant='outlined' className='mr2'>Cancel</Button>
        <Button onClick={saveReport} variant="contained" color="primary">{initialValues ? "Update" : "Save"}</Button>
      </div>
      }
      
    </div>
  );
};